import axios from 'axios';
import { API_URL } from 'utils';
import { mixed, object, string } from 'yup';

export const registerSchema = object({
  email: string().email().required(),
  password: string().min(8).required(),
  company: string().min(3).required(),
  address1: string().min(2).required(),
  district: string().min(2).required(),
  area: string().min(2).required(),
  province: string().min(3).required(),
  zipcode: mixed().required(),
  prefix: string().min(2).required(),
  name: string().min(2).required(),
  lastname: string().min(2).required(),
  idCard: string().min(13).required(),
  phone: string().min(9).max(10).required(),
}).required();

/**
 * @typedef {import('yup').InferType<typeof registerSchema>} RegisterData
 *
 * @typedef {object} TRegister
 * @property {string} _id
 * @property {string} email
 */

/**
 * @param {RegisterData} data
 * @return {Promise<import('axios').AxiosResponse<TRegister, {}>>}
 */
export default async function register(data, code) {
  try {
    console.log(data);
    return await axios.post(`${API_URL}/auth/register${code !== undefined ? `?code=${code}` : ''}`, data);
  } catch (err) {
    throw err;
  }
}
